module.exports = __webpack_public_path__ + "img/ESG_aloldalhoz_grafikak_03.bd580522.jpg";